// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1eZyu{display:flex;flex-flow:column nowrap}.pe\\+O4{gap:10px;height:calc(100vh - 200px)}.u48Qy{gap:10px;background-color:#fff7f7;padding:20px 30px}", "",{"version":3,"sources":["webpack://./src/uikit/Table/Table.scss"],"names":[],"mappings":"AAAA,QACE,YAAA,CACA,uBAAA,CAEA,QACE,QAAA,CACA,0BAAA,CAGF,OACE,QAAA,CACA,wBAAA,CACA,iBAAA","sourcesContent":[".wrap {\n  display: flex;\n  flex-flow: column nowrap;\n\n  &__admin {\n    gap: 10px;\n    height: calc(100vh - 200px);\n  }\n\n  &__leaderboard {\n    gap: 10px;\n    background-color: #fff7f7;\n    padding: 20px 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": "_1eZyu",
	"wrap__admin": "pe+O4",
	"wrapAdmin": "pe+O4",
	"wrap__leaderboard": "u48Qy",
	"wrapLeaderboard": "u48Qy"
};
export default ___CSS_LOADER_EXPORT___;
